export default {
  PaymentReminder: 'PaymentReminder',
  CustomMessage: 'CustomMessage',
}
